import { NhostClient as N, removeParameterFromWindow as A, createChangeEmailMachine as L, changeEmailPromise as M, createChangePasswordMachine as R, changePasswordPromise as D, createEnableMfaMachine as V, generateQrCodePromise as F, activateMfaPromise as j, createFileUploadMachine as $, uploadFilePromise as q, createMultipleFilesUploadMachine as Q, uploadMultipleFilesPromise as _, encodeQueryParameters as H, rewriteRedirectTo as G, createResetPasswordMachine as J, resetPasswordPromise as W, createSendVerificationEmailMachine as Y, sendVerificationEmailPromise as z, signInAnonymousPromise as B, signInEmailPasswordPromise as K, signInMfaTotpPromise as X, signInEmailPasswordlessPromise as Z, signInPATPromise as b, signInSmsPasswordlessPromise as ee, signInSmsPasswordlessOtpPromise as U, signOutPromise as te, signUpEmailPasswordPromise as se } from "@nhost/nhost-js";
import { getCurrentInstance as ne, inject as oe, warn as re, computed as S, unref as p, ref as C, reactive as k, toRefs as ce } from "vue";
import { useSelector as n, useInterpret as w } from "@xstate/vue";
import { toRefs as ie } from "@vueuse/core";
import ae from "jwt-decode";
const y = Symbol("default-nhost-client");
let ue;
function P() {
  let s;
  const e = ue;
  if (!ne())
    s = () => e;
  else {
    const o = oe(y, null);
    s = () => o;
  }
  function t() {
    const o = s();
    if (!o)
      throw new Error(
        "No Nhost client found. Use provideNhostClient() if you are outside of a component setup."
      );
    return o;
  }
  return {
    resolveNhostClient: t,
    get nhost() {
      return t();
    }
  };
}
class Pe extends N {
  constructor(e) {
    var t;
    super({ ...e, start: !0 }), this.autoSignIn = (t = e.autoSignIn) != null ? t : !0;
  }
  /**
   * @internal
   * This method transforms the NhostClient class into a Vue plugin
   */
  install(e) {
    const t = this.autoSignIn;
    if (e.provide(y, this), t) {
      const o = e.config.globalProperties.$router;
      if (!o)
        return;
      if (o.options.history.base) {
        re(
          "[Nhost]: Vue-router is configured with a history Hash Mode. Refresh tokens will not be removed from the hash."
        );
        return;
      }
      o.afterEach(() => {
        A("refreshToken"), A("type");
      });
    }
  }
}
const f = () => {
  const { nhost: s } = P();
  return S(() => {
    const e = s.auth.client.interpreter;
    if (!e)
      throw Error("No interpreter");
    return e;
  });
}, T = () => {
  const s = f();
  return n(s.value, (e) => e.context.accessToken.value);
}, O = () => {
  const s = f();
  return n(s.value, (e) => e.matches({ authentication: "signedIn" }));
}, we = () => {
  const s = f();
  return ie(
    n(
      s.value,
      (e) => ({
        isAuthenticated: e.matches({ authentication: "signedIn" }),
        isLoading: e.hasTag("loading"),
        error: e.context.errors.authentication || null,
        isError: e.matches({ authentication: { signedOut: "failed" } }),
        connectionAttempts: e.context.importTokenAttempts
      }),
      (e, t) => e.isAuthenticated === t.isAuthenticated && e.isLoading === t.isLoading && e.connectionAttempts === t.connectionAttempts
    )
  );
}, E = (s) => {
  const e = p(s);
  return Array.isArray(e) ? e.map((t) => E(t)) : e && typeof e == "object" ? Object.entries(e).reduce(
    (t, [o, l]) => ({ ...t, [o]: E(l) }),
    {}
  ) : e;
}, xe = (s) => {
  const { nhost: e } = P(), t = w(L(e.auth.client)), o = n(t, (h) => h.matches("requesting")), l = n(t, (h) => h.context.error), v = n(t, (h) => h.matches("idle.error")), m = n(t, (h) => h.matches("idle.success"));
  return { changeEmail: (h) => M(t, p(h), E(s)), isLoading: o, error: l, isError: v, needsEmailVerification: m };
}, Se = () => {
  const { nhost: s } = P(), e = w(R(s.auth.client)), t = n(e, (d) => d.matches("requesting")), o = n(e, (d) => d.context.error), l = n(e, (d) => d.matches("idle.error")), v = n(e, (d) => d.matches("idle.success"));
  return { changePassword: (d) => D(e, p(d)), isLoading: t, error: o, isError: l, isSuccess: v };
}, Ie = () => {
  const { nhost: s } = P(), e = w(V(s.auth.client)), t = n(
    e,
    (r) => r.matches({ idle: "error" }) || r.matches({ generated: { idle: "error" } })
  ), o = n(e, (r) => r.matches("generating")), l = n(e, (r) => r.matches("generated")), v = n(e, (r) => r.matches({ generated: "activating" })), m = n(e, (r) => r.matches({ generated: "activated" })), d = n(e, (r) => r.context.error), h = n(e, (r) => r.context.imageUrl || "");
  return {
    generateQrCode: () => F(e),
    isGenerating: o,
    qrCodeDataUrl: h,
    isGenerated: l,
    activateMfa: (r) => j(e, p(r)),
    isActivating: v,
    isActivated: m,
    isError: t,
    error: d
  };
}, le = () => {
  const s = T();
  return S(() => s.value ? ae(s.value) : null);
}, de = (s) => {
  const { nhost: e } = P(), t = (u) => {
    s.send({
      type: "ADD",
      file: u.file,
      bucketId: u.bucketId || g.value
    });
  }, o = (u) => q(
    {
      url: e.storage.url,
      accessToken: e.auth.getAccessToken(),
      adminSecret: e.adminSecret,
      ...u
    },
    s
  ), l = () => {
    s.send("CANCEL");
  }, v = () => {
    s.send("DESTROY");
  }, m = n(s, (u) => u.matches("uploading")), d = n(s, (u) => u.matches("uploaded")), h = n(s, (u) => u.matches("error")), a = n(s, (u) => u.context.error || null), c = n(s, (u) => u.context.progress), r = n(s, (u) => u.context.id), g = n(s, (u) => u.context.bucketId), i = n(s, (u) => {
    var I;
    return (I = u.context.file) == null ? void 0 : I.name;
  });
  return {
    add: t,
    upload: o,
    cancel: l,
    destroy: v,
    isUploaded: d,
    isUploading: m,
    isError: h,
    error: a,
    progress: c,
    id: r,
    bucketId: g,
    name: i
  };
}, Ae = () => {
  const s = w($);
  return de(s);
}, he = () => {
  const s = le();
  return S(() => {
    var e;
    return ((e = s.value) == null ? void 0 : e["https://hasura.io/jwt/claims"]) || null;
  });
}, Ue = (s) => {
  const e = he();
  return S(() => {
    var o;
    const t = p(s);
    return ((o = e.value) == null ? void 0 : o[t.startsWith("x-hasura-") ? t : `x-hasura-${t}`]) || null;
  });
}, Ce = () => {
  const { nhost: s } = P(), e = C([]), t = w(Q, {}, (g) => {
    g.event.type === "UPLOAD_ERROR" ? e.value = g.context.files.filter((i) => {
      var u;
      return (u = i.getSnapshot()) == null ? void 0 : u.context.error;
    }) : (g.matches("uploaded") || g.event.type === "CLEAR") && e.value.length > 0 && (e.value = []);
  }), o = (g) => {
    t.send({ type: "ADD", ...g });
  }, l = (g) => _(
    {
      url: s.storage.url,
      accessToken: s.auth.getAccessToken(),
      adminSecret: s.adminSecret,
      ...g
    },
    t
  ), v = () => {
    t.send("CANCEL");
  }, m = () => {
    t.send("CLEAR");
  }, d = n(t, (g) => g.matches("uploading")), h = n(t, (g) => g.matches("uploaded")), a = n(t, (g) => g.matches("error")), c = n(t, (g) => g.context.progress), r = n(t, (g) => g.context.files);
  return {
    upload: l,
    add: o,
    clear: m,
    cancel: v,
    progress: c,
    isUploaded: h,
    isUploading: d,
    files: r,
    isError: a,
    errors: e
  };
}, ke = (s) => {
  const { nhost: e } = P();
  return k(
    new Proxy({}, {
      get(t, o) {
        const l = E(s);
        return H(
          `${e.auth.client.backendUrl}/signin/provider/${o}`,
          G(e.auth.client.clientUrl, l)
        );
      }
    })
  );
}, ye = (s) => {
  const { nhost: e } = P(), t = w(J(e.auth.client)), o = n(t, (h) => h.matches("requesting")), l = n(t, (h) => h.matches({ idle: "success" })), v = n(t, (h) => h.matches({ idle: "error" })), m = n(t, (h) => h.context.error);
  return { resetPassword: (h) => W(t, p(h), E(s)), isLoading: o, isError: v, isSent: l, error: m };
}, Te = (s) => {
  const { nhost: e } = P(), t = w(Y(e.auth.client)), o = n(t, (m) => m.matches("requesting")), l = k({
    isError: !1,
    error: null,
    isSent: !1
  });
  return { sendEmail: (m) => z(t, p(m), E(s)), isLoading: o, ...ce(l) };
}, x = (s) => {
  const e = f();
  return n(
    e.value,
    (t) => t.context.errors[s] || null,
    (t, o) => (t == null ? void 0 : t.error) === (o == null ? void 0 : o.error)
  );
}, Oe = () => {
  const s = f(), e = () => B(s.value), t = x("authentication"), o = n(
    s.value,
    (m) => m.matches({ authentication: { authenticating: "anonymous" } })
  ), l = O(), v = n(
    s.value,
    (m) => m.matches({ authentication: { signedOut: "failed" } })
  );
  return { signInAnonymous: e, isLoading: o, isSuccess: l, isError: v, error: t };
}, Ne = () => {
  const s = f(), e = (i, u) => K(s.value, p(i), p(u)), t = (i) => X(s.value, p(i)), o = n(
    s.value,
    (i) => i.context.user,
    (i, u) => (i == null ? void 0 : i.id) === (u == null ? void 0 : u.id)
  ), l = n(s.value, (i) => i.context.accessToken.value), v = n(s.value, (i) => i.context.refreshToken.value), m = x("authentication"), d = O(), h = n(
    s.value,
    (i) => i.matches({ authentication: { authenticating: "password" } }),
    (i, u) => i === u
  ), a = n(
    s.value,
    (i) => i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }),
    (i, u) => i === u
  ), c = n(s.value, (i) => i.context.mfa), r = n(
    s.value,
    (i) => i.matches({ authentication: { signedOut: "needsMfa" } }),
    (i, u) => i === u
  ), g = n(
    s.value,
    (i) => i.matches({ authentication: { signedOut: "failed" } }),
    (i, u) => i === u
  );
  return {
    accessToken: l,
    refreshToken: v,
    error: m,
    isError: g,
    isLoading: h,
    isSuccess: d,
    needsEmailVerification: a,
    needsMfaOtp: r,
    mfa: c,
    sendMfaOtp: t,
    signInEmailPassword: e,
    user: o
  };
}, Le = (s) => {
  const e = f(), t = (d) => Z(e.value, p(d), E(s)), o = x("registration"), l = n(
    e.value,
    (d) => d.matches("registration.passwordlessEmail")
  ), v = n(
    e.value,
    (d) => d.matches("registration.incomplete.needsEmailVerification")
  ), m = n(
    e.value,
    (d) => d.matches("registration.incomplete.failed")
  );
  return { signInEmailPasswordless: t, isLoading: l, isSuccess: v, isError: m, error: o };
}, Me = () => {
  const s = f(), e = (a) => b(s.value, p(a)), t = n(
    s.value,
    (a) => a.context.user,
    (a, c) => (a == null ? void 0 : a.id) === (c == null ? void 0 : c.id)
  ), o = n(s.value, (a) => a.context.accessToken.value), l = n(s.value, (a) => a.context.refreshToken.value), v = n(
    s.value,
    (a) => a.context.errors.authentication || null,
    (a, c) => (a == null ? void 0 : a.error) === (c == null ? void 0 : c.error)
  ), m = n(
    s.value,
    (a) => a.matches({ authentication: "signedIn" })
  ), d = n(
    s.value,
    (a) => a.matches({ authentication: { authenticating: "password" } }),
    (a, c) => a === c
  ), h = n(
    s.value,
    (a) => a.matches({ authentication: { signedOut: "failed" } }),
    (a, c) => a === c
  );
  return {
    accessToken: o,
    refreshToken: l,
    error: v,
    isError: h,
    isLoading: d,
    isSuccess: m,
    signInPAT: e,
    user: t
  };
};
function Re(s) {
  const e = f(), t = C(""), o = (c, r = s) => (t.value = p(c), ee(
    e.value,
    p(c),
    E(r)
  )), l = async (...c) => {
    if (c.length === 2) {
      const [g, i] = c;
      return U(e.value, p(g), p(i));
    }
    const [r] = c;
    return U(e.value, p(t), p(r));
  }, v = n(
    e.value,
    (c) => c.context.errors.registration || null,
    (c, r) => (c == null ? void 0 : c.error) === (r == null ? void 0 : r.error)
  ), m = n(
    e.value,
    (c) => c.matches("registration.passwordlessSms") || c.matches("registration.passwordlessSmsOtp")
  ), d = n(e.value, (c) => c.matches("authentication.signedIn")), h = n(
    e.value,
    (c) => c.matches("registration.incomplete.needsOtp")
  ), a = n(
    e.value,
    (c) => c.matches("registration.incomplete.failed")
  );
  return { signInSmsPasswordless: o, sendOtp: l, isLoading: m, isSuccess: d, needsOtp: h, isError: a, error: v };
}
const De = () => {
  const s = f(), e = (l) => te(s.value, typeof p(l) == "boolean" ? p(l) : !1), t = n(
    s.value,
    (l) => l.matches({ authentication: { signedOut: "success" } })
  ), o = x("signout");
  return { signOut: e, isSuccess: t, error: o };
}, me = () => {
  const s = f();
  return n(
    s.value,
    (e) => e.context.user,
    (e, t) => JSON.stringify(e) === JSON.stringify(t)
  );
}, Ve = (s) => {
  const e = f(), t = n(
    e.value,
    (r) => r.matches("registration.incomplete.failed")
  ), o = x("registration"), l = n(
    e.value,
    (r) => r.matches("registration.emailPassword")
  ), v = n(
    e.value,
    (r) => r.matches({
      authentication: "signedIn",
      registration: "complete"
    })
  ), m = n(
    e.value,
    (r) => r.matches("registration.incomplete.needsEmailVerification")
  ), d = T(), h = n(e.value, (r) => r.context.refreshToken.value), a = me();
  return {
    signUpEmailPassword: (r, g, i) => se(e.value, p(r), p(g), {
      ...E(s),
      ...E(i)
    }),
    isLoading: l,
    isSuccess: v,
    isError: t,
    error: o,
    needsEmailVerification: m,
    accessToken: d,
    refreshToken: h,
    user: a
  };
}, Fe = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.avatarUrl;
    },
    (e, t) => e === t
  );
}, je = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.defaultRole;
    },
    (e, t) => e === t
  );
}, $e = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.displayName;
    },
    (e, t) => e === t
  );
}, qe = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.email;
    },
    (e, t) => e === t
  );
}, Qe = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.id;
    },
    (e, t) => e === t
  );
}, _e = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.isAnonymous;
    },
    (e, t) => e === t
  );
}, He = () => {
  const s = f();
  return n(
    s.value,
    (e) => {
      var t;
      return (t = e.context.user) == null ? void 0 : t.locale;
    },
    (e, t) => e === t
  );
}, Ge = () => {
  const s = f();
  return n(s.value, (e) => {
    var t;
    return e.matches("authentication.signedIn") ? ((t = e.context.user) == null ? void 0 : t.roles) || [] : [];
  });
};
export {
  y as DefaultNhostClient,
  Pe as NhostClient,
  T as useAccessToken,
  f as useAuthInterpreter,
  O as useAuthenticated,
  we as useAuthenticationStatus,
  xe as useChangeEmail,
  Se as useChangePassword,
  Ie as useConfigMfa,
  le as useDecodedAccessToken,
  Ae as useFileUpload,
  de as useFileUploadItem,
  Ue as useHasuraClaim,
  he as useHasuraClaims,
  Ce as useMultipleFilesUpload,
  P as useNhostClient,
  ke as useProviderLink,
  ye as useResetPassword,
  Te as useSendVerificationEmail,
  Oe as useSignInAnonymous,
  Ne as useSignInEmailPassword,
  Le as useSignInEmailPasswordless,
  Me as useSignInPAT,
  Re as useSignInSmsPasswordless,
  De as useSignOut,
  Ve as useSignUpEmailPassword,
  Fe as useUserAvatarUrl,
  me as useUserData,
  je as useUserDefaultRole,
  $e as useUserDisplayName,
  qe as useUserEmail,
  Qe as useUserId,
  _e as useUserIsAnonymous,
  He as useUserLocale,
  Ge as useUserRoles
};
//# sourceMappingURL=index.esm.js.map
